module.exports = __webpack_public_path__ + "media/images/label_formats-68a526716c8a6d3bcab42e8c6c4d4e44.png";